import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'

export const EasyPayEditSubmittedPage: FC = () => {
  const { t } = useTranslation('easyPayEditSubmittedPage')

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
    >
    </ContentLayout>
  )
}
